import { TChatCommand, TChatCommandString, parseAwaitDays } from "../../../../../domain/codecs/form/ChatsMessageForm";

export type TCommand =
    TChatCommand
    & { isExpandable?: boolean, days?: number, maxDays?: number }
;

export const TCommandToTCommandString = (command: TCommand): TChatCommandString => {
    if (command.target === undefined) {
        return `#${command.action}`;
    }
    if (command.days !== undefined) {
        return `#${command.action}:${command.target}:${command.days}`;
    }
    return `#${command.action}:${command.target}`;
};

export const tryBuildAwaitDayOverrideSuggestions = (commands: Array<TCommand>, filterText: string): Array<TCommand> | null => {
    const segments = filterText.split(":");

    if (segments.length !== 3) {
        return null;
    }

    const [action, entityName, daysText] = segments;

    if (action !== "await") {
        return null;
    }

    const matchingEntity = commands.find((command) =>
        command.action === "await"
        && command.target !== undefined
        && command.target.toLowerCase() === entityName.toLowerCase()
    );

    if (matchingEntity === undefined || matchingEntity.target === undefined) {
        return null;
    }

    if (daysText.length === 0) {
        return [{ action: "await", target: matchingEntity.target }];
    }

    const days = parseAwaitDays(daysText, matchingEntity.maxDays);

    if (days === null) {
        return [];
    }

    return [{ action: "await", target: matchingEntity.target, days }];
};
